export default "__VITE_ASSET__Cq09Y4Cc__"